<template>
  <div
    :class="
      `${!paymentType ? 'recharge__wrapper' : 'recharge__wrapper--small'}`
    "
  >
    <div
      class="recharge__item"
      :class="paymentType === 'ASAAS_CREDIT_CARD' && 'active'"
      @click="$emit('paymentType', 'ASAAS_CREDIT_CARD')"
    >
      <v-icon class="recharge__item-icon">
        mdi-credit-card-outline
      </v-icon>
      <h2 class="mt-3">
        <span class="d-block caption">
          {{ $t('onboarding.payment.with') }}
        </span>
        <span class="font-weight-bold">
          {{ $t('onboarding.payment.creditCard.title') }}
        </span>
      </h2>
    </div>
    <div
      class="recharge__item"
      :class="paymentType === 'ASAAS_PIX' && 'active'"
      @click="$emit('paymentType', 'ASAAS_PIX')"
    >
      <PixIcon
        class="recharge__item-icon"
        width="50"
        height="57"
        opacity="0.1"
      />
      <h2 class="mt-3">
        <span class="d-block caption">
          {{ $t('onboarding.payment.with') }}
        </span>
        <span class="font-weight-bold">
          {{ $t('onboarding.payment.pix.title') }}
        </span>
      </h2>
    </div>
  </div>
</template>

<script>
import PixIcon from '@/components/icons/Pix'

export default {
  name: 'OnboardingTypeSelect',

  components: {
    PixIcon,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    paymentType: {
      type: String,
      default: null,
    },
  },
}
</script>
